import { render, staticRenderFns } from "./ConvenioUpdate.vue?vue&type=template&id=00ba8114&scoped=true"
import script from "./ConvenioUpdate.vue?vue&type=script&lang=js"
export * from "./ConvenioUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba8114",
  null
  
)

export default component.exports